<template>
  <div class="edu-wrap">
    <Header />
    <div class="edu-wrap__banner">
      <img src="../../assets/homeSwiper0.png" />
    </div>
    <div class="edu-wrap__tab">
      <div class="edu-wrap__tab__inner">
        <div
          class="edu-wrap__tab__tab-item"
          :class="{active: activeTab === '投资者教育'}"
          @click="toggleTag('投资者教育')"
        >投资者教育</div>
        <div
          class="edu-wrap__tab__tab-item"
          :class="{active: activeTab === '视频宣传'}"
          @click="toggleTag('视频宣传')"
        >视频宣传</div>
        <div
          class="edu-wrap__tab__tab-item"
          :class="{active: activeTab === '调查问卷'}"
          @click="toggleTag('调查问卷')"
        >调查问卷</div>

        <div
          class="edu-wrap__tab__tab-item"
          :class="{active: activeTab === '风险提示'}"
          @click="toggleTag('风险提示')"
        >风险提示</div>
      </div>
    </div>

    <div class="edu-wrap__content">
      <div v-show="activeTab === '投资者教育'">
        <h2 class="title">2020年防范非法期货宣传月</h2>
        <p
          class="indent"
        >时值2020年5月15日全国投资者保护宣传日，为贯彻落实中国证监会、基金业协会投资保护工作部署要求，积极响应号召，盈融达投资（北京）有限公司特别策划“理性投资，远离非法证券期货陷阱”为主题的投资者教育专项宣传。</p>
        <p
          class="indent"
        >今年是防范化解重大风险攻坚决胜年，也将迎来第二个全国投资者保护月。保护投资者权益是一切基金管理活动的出发点，防范以私募基金的名义开展非法集资活动是行业的使命。为进一步增强投资者的风险防范意识，协会于5月10日至6月15日组织开展“防范非法证券期货宣传月”活动。</p>
        <img src="../../assets/高收益意味着高风险.png" alt="高收益意味着高风险" />
        <img src="../../assets/非法证券期货活动不受保护.png" alt="非法证券期货活动不受保护" />
        <div class="edu-wrap__content__foot">
          <p class="right">盈融达投资（北京）有限公司</p>
          <p class="right">2020年5月20日</p>
        </div>
      </div>
      <div v-show="activeTab === '视频宣传'">
        <h2 class="title">2020年防范非法期货宣传月</h2>
        <p
          class="indent"
        >时值2020年5月15日全国投资者保护宣传日，为贯彻落实中国证监会、基金业协会投资保护工作部署要求，积极响应号召，盈融达投资（北京）有限公司特别策划“理性投资，远离非法证券期货陷阱”为主题的投资者教育专项宣传。</p>
        <p class="indent">请投资者观看防范非法证券期货宣传月推荐视频链接，维护投资者合法权益。</p>
        <div class="list-wrap">
          <div v-for="(item,index) in hrefList" :key="index">
            <p class="list-item">{{index+1}} {{item.title}}</p>
            <p class="list-item">
              <a target="__blank" :href="item.href">{{item.href}}</a>
            </p>
          </div>
        </div>
        <div class="edu-wrap__content__foot">
          <p class="right">盈融达投资（北京）有限公司</p>
          <p class="right">2020年5月15日</p>
        </div>
      </div>
      <div v-show="activeTab === '调查问卷'">
        <h2 class="title">欢迎参加协会“5·15”私募基金有奖问答活动！</h2>
        <p
          class="indent"
        >值此“5·15全国投资者保护宣传日来临之际”，在证监会市场二部、投资者保护局指导下，中国证券投资基金业协会特开展“5·15”全国投资者保护宣传日私募基金投资者有奖问答活动，广泛普及私募基金投资常识，帮助投资者深入了解监管底线。</p>
        <img src="../../assets/调查问卷.png" alt="调查问卷">
        <p>现诚邀广大私募基金投资者、从业人员和相关人员参与有奖问答，请扫描海报中小程序码参与答题，完成8题即可通关，轻松赢取红包奖励。</p>
        <p class="title">一、活动时间</p>
        <p>2020年5月15日至2020年5月31日</p>
        <p class="title">二、活动规则</p>
        <p>每次问答在私募投资者知识题库中随机抽取8道题目（5道单选题、3道多选题），全部答对者且完成问卷调查后即有1次现金红包抽奖机会。每个账号每天有3次答题机会，每天最多可抽取1次红包，奖金2—5元不等，抽中后当日发放。红包数量有限，先到先得。</p>
        <p class="title">三、活动须知</p>
        <p>本次活动由中国证券投资基金业协会组织开展，最终解释权归中国证券投资基金业协会所有。活动过程中，如发现用户使用作弊方法参与活动，中国证券投资基金业协会有权取消用户的获奖资格。</p>
        <div class="edu-wrap__content__foot">
          <p class="right">盈融达投资（北京）有限公司</p>
          <p class="right">2020年5月15日</p>
        </div>
      </div>
      <div v-show="activeTab === '风险提示'">
        <h2 class="title">
          关于警惕冒用协会会员机构和私募基金<br>
          管理人名义进行非法活动的提示</h2>
        <p>
          协会郑重提示，广大投资者要加强防范、注意辨别不法分子冒用协会会员机构或在协会登记的私募基金管理人的名义进行违法活动，包括并不限于冒用公司名称、注册商标，盗用从业人员肖像伪造非法APP、非法网站并实施违法宣传和违法募集资金等活动。建议通过登陆中国证券投资基金业协会官方网站（<a href="www.amac.org.cn">www.amac.org.cn</a>)，查询私募基金管理人公示信息，保护自身合法权益不受侵害。
        </p><br>
        <p>
          协会郑重声明，坚决反对任何冒用协会会员机构和在协会登记的私募基金管理人的名义开展违法活动。投资者如发现上述不法行为，请及时收集保存证据，并立即向公安机关、监管部门举报。
        </p><br>
        <p>
          协会郑重要求，各会员机构、私募基金管理人也应密切注意以上侵权行为，一经发现，及时收集保存证据，立即向公安机关、监管部门举报，向协会报告。协会将和会员机构、以及在协会登记的私募基金管理人一道，依法维护行业的合法权益。
        </p><br>
        <p>
          协会将一如既往地以维护投资者合法权益为首要职责，坚持以法治引领行业自律管理，营造健康有序的行业发展环境，为广大投资者提供安全有效的财富管理服务。
        </p>
        <div class="edu-wrap__content__foot">
          <p class="right">中国证券投资基金业协会</p>
          <p class="right">二〇二〇年五月七日</p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";

export default {
  name: "InvestmentEducation",
  data() {
    return {
      activeTab: "投资者教育",
      hrefList: [
        {
          title: "“守护财富行动，远离投资陷阱”专题片",
          href: "https://v.qq.com/x/page/r06065l5nf1.html"
        },
        {
          title: "“你财知道”投教动漫剧第一集：悟空私募基金捉妖记",
          href: "https://v.qq.com/x/cover/4dtrulr1jo3hufb/v0384yt8zdy.html"
        },
        {
          title: "“你财知道”投教动漫剧第二集：无底套路迷人心 终有火眼识妖精",
          href: "https://v.qq.com/x/cover/4dtrulr1jo3hufb/b0384rv58aq.html"
        },
        {
          title:
            "“你财知道”投教动漫剧第三集：这个阴招太狠，连强势的银行都躺枪了",
          href: "https://v.qq.com/x/page/t0384dmuscn.html"
        },
        {
          title:
            "“你财知道”投教动漫剧第四集：你以为稳赚不赔，却不知正在掉进陷阱",
          href: "https://v.qq.com/x/page/h03851kdbu3.html"
        },
        {
          title: "“你财知道”投教动漫剧第五集：假冒巴菲特，坑人的骗子要遭清算了",
          href: "https://v.qq.com/x/page/a03858fg6wx.html"
        },
        {
          title:
            "“你财知道”投教动漫剧第六集：四大陷阱被揭穿，私募防骗终极指南出炉",
          href: "https://v.qq.com/x/page/p0385c2zqhs.html"
        }
      ]
    };
  },
  methods: {
    toggleTag(tab) {
      this.activeTab = tab;
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped lang="scss">
.edu-wrap {
  min-height: 100%;
  background: rgba(245, 245, 245, 1);
  padding-top: 6rem;

  &__banner {
    img {
      width: 100%;
      margin-bottom: 0;
    }
  }

  &__tab {
    height: 5.25rem;
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: 0rem 0.13rem 0.25rem 0rem rgba(220, 220, 220, 0.5);

    &__inner {
      width: 75rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
    }

    &__tab-item {
      width: 12.5rem;
      height: 2.75rem;
      line-height: 2.75rem;
      text-align: center;
      font-size: 1.125rem;
      transition: all 0.3s ease;
      cursor: pointer;

      &.active {
        background: rgba(216, 183, 61, 1);
        border-radius: 0.31rem;
        color: #fff;
      }
    }
  }

  &__content {
    width: 75rem;
    margin: 0 auto;
    padding: 3.13rem 6.26rem;
    padding-bottom: 180px;
    background-color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    color: #323232;
    font-size: 1rem;
    overflow: hidden;

    &__foot {
      margin-top: 5rem;
    }

    h2.title {
      font-size: 2.25rem;
      color: #323232;
      line-height: 3.38rem;
      text-align: center;
      margin-bottom: 3.31rem;
    }
    p {
      line-height: 2rem;
      text-align: left;
      text-indent: 2rem;
    }
    p.title{
      margin: 3rem 0;
    }
    p.indent {
      text-indent: 2rem;
    }
    p.right {
      text-align: right;
    }
    .list-wrap {
      margin-top: 3rem;
    }
    p.list-item {
      text-indent: 4rem;
    }
    img {
      width: auto;
      height: auto;
      margin: 1.25rem auto 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investment-edu/InvestmentEducation.vue